import React, { ChangeEvent, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import { setRouteObj } from '../../store/slices/metaDataSlice';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setRouteArr } from '../../store/slices/metaDataSlice';
import { TypographyListStyled } from './style';

export default function CheckboxesGroup() {
  const dispatch = useDispatch();
  const { optedOptions } = useAppSelector(metaDataSelector);
  const { routeObj, routeArr } = optedOptions;
  const [state, setState] = useState(routeObj);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const arrVal = '/' + event.target.name.replace('_', '-');
    if (event.target.checked && !routeArr.includes(arrVal)) {
      dispatch(setRouteArr([...routeArr, arrVal]));
    } else {
      dispatch(setRouteArr(routeArr.filter((item) => item !== arrVal)));
    }
    setState({
      ...state,
      [event.target.name]: event.target.checked
    });
  };

  useEffect(() => {
    dispatch(setRouteObj({ ...state }));
  }, [state]);

  const { estimating_requirements, malnutrition_screening, muscle_screening } =
    state;

  return (
    <Box sx={{ display: 'flex', gap: '1.25rem' }}>
      <FormControl
        sx={{ m: 3, padding: '1.875rem', margin: '0px' }}
        component="fieldset"
        variant="standard"
      >
        <FormLabel component="legend"></FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={estimating_requirements}
                onChange={handleChange}
                name="estimating_requirements"
                data-testid="estimating_requirements"
                style={{ color: '#004F71' }}
              />
            }
            label={
              <TypographyListStyled>
                Estimate Nutritional Requirements
              </TypographyListStyled>
            }
            // label="Estimate Nutritional Requirements"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={malnutrition_screening}
                onChange={handleChange}
                name="malnutrition_screening"
                data-testid="malnutrition_screening"
                style={{ color: '#004F71' }}
              />
            }
            label={
              <TypographyListStyled>
                Malnutrition Assessment
              </TypographyListStyled>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={muscle_screening}
                onChange={handleChange}
                name="muscle_screening"
                data-testid="muscle_screening"
                style={{ color: '#004F71' }}
              />
            }
            label={
              <TypographyListStyled>Muscle Assessment</TypographyListStyled>
            }
          />
        </FormGroup>
        <FormHelperText></FormHelperText>
      </FormControl>
    </Box>
  );
}
